 

const iconName = 'phone';
const width = 18;
const height = 18;
const svgPathData =
	'M17.487 12.72l-3.938-1.688a.844.844 0 0 0-.984.243l-1.744 2.13a13.031 13.031 0 0 1-6.23-6.23l2.131-1.743a.842.842 0 0 0 .243-.985L5.277.51A.85.85 0 0 0 4.31.02L.654.865A.844.844 0 0 0 0 1.687C0 10.705 7.31 18 16.313 18c.393 0 .734-.27.822-.654l.844-3.656a.854.854 0 0 0-.492-.97z';

export default {
	iconName: iconName,
	icon: [width, height, svgPathData],
};


